import { CheckCircle, Phone } from '@/components/pages/icons';
import Alert from '@/components/pages/alert';
import clsx from 'clsx';
import type { FormCompletionResult } from '@jlg-website/shared';

type DuplicatedMessageProps = {
  data: FormCompletionResult;
  className?: string;
};

/**
 * Completion message shown when the lead is a duplicate submission (Figma node 6092-17124).
 * Content is admin-managed via `form_messages`. Title scales from 32px to 48px at the `@lg`
 * container.
 */
export default function DuplicatedMessage({ data, className }: DuplicatedMessageProps) {
  return (
    <div className={clsx('text-brand-text-button', className)}>
      {data.alert && (
        <Alert variant="success" icon={<CheckCircle />} className="mb-6">
          <div dangerouslySetInnerHTML={{ __html: data.alert }} />
        </Alert>
      )}

      <div className="flex flex-col gap-2">
        {data.title && (
          <h2
            className="text-[32px] font-normal leading-[120%] tracking-[-0.96px] @lg:text-5xl @lg:leading-[110%] @lg:tracking-[-1.44px]"
            dangerouslySetInnerHTML={{ __html: data.title }}
          />
        )}
        {data.message && (
          <div className="text-base leading-normal" dangerouslySetInnerHTML={{ __html: data.message }} />
        )}
      </div>

      {data.help && (
        <Alert icon={<Phone />} className="mt-6">
          <div dangerouslySetInnerHTML={{ __html: data.help }} />
        </Alert>
      )}
    </div>
  );
}
